import { getSubtleCrypto } from './subtle';

export async function sha256(data: Uint8Array): Promise<Uint8Array> {
  const subtle = getSubtleCrypto();
  const digest = await subtle.digest('SHA-256', data as BufferSource);
  return new Uint8Array(digest);
}
